import { useState } from 'react';
import { Tabs } from '@/components/application/tabs/tabs';
import { useTranslation } from 'react-i18next';
import { ApiUsageTab } from './api-usage-tab';
import { MetabaseAnalyticsTab } from './metabase-analytics-tab';

export const AnalyticsPage = () => {
    const { t: _t } = useTranslation(['pages:analytics', 'common']);
    const [activeTab, setActiveTab] = useState('api-usage');

    return (
        <div className="space-y-6">
            {/* Header */}
            <div className="flex items-center justify-between">
                <div>
                    <h1 className="text-2xl font-semibold text-primary">Analytics</h1>
                    <p className="text-tertiary mt-1">
                        Monitor API usage and view business analytics
                    </p>
                </div>
            </div>

            {/* Tabs */}
            <Tabs selectedKey={activeTab} onSelectionChange={(key) => setActiveTab(key as string)}>
                <Tabs.List items={[
                    { id: "api-usage", label: "API Usage" },
                    { id: "analytics", label: "Analytics" }
                ]}>
                    <Tabs.Item id="api-usage" label="API Usage" />
                    <Tabs.Item id="analytics" label="Analytics" />
                </Tabs.List>

                {/* API Usage Tab */}
                <Tabs.Panel id="api-usage">
                    <ApiUsageTab />
                </Tabs.Panel>

                {/* Analytics Tab (Metabase) */}
                <Tabs.Panel id="analytics">
                    <MetabaseAnalyticsTab />
                </Tabs.Panel>
            </Tabs>
        </div>
    );
};
